import Config from '../config'

const fetchInstance = function (URL, data) {
  if (!URL) {
    URL = Config.payments.adyen.pos.urls.host
  }

  const _default_ = {
    method: 'POST',
    headers: {
      'X-API-Key': Config.payments.adyen.pos.key,
      'Content-Type': 'application/json'
    }
  }
  const config = Object.assign({}, _default_, data)
  return fetch(URL, config)
}

export function getUrl (key, url) {
  return `${Config.payments.adyen.pos.urls.host}${Config.payments.adyen[key].urls[url]}`
}

export default fetchInstance
